import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import Pagination from "@mui/material/Pagination";
import { PaginationPropsOverrides, useGridApiContext } from "@mui/x-data-grid";
import React, { FC } from "react";
import { SelectField } from "../..";
import { defaultPageSizeOptions } from "../model/constants";

interface IPaginationComponentProps extends PaginationPropsOverrides {
  "aria-disabled"?: string | boolean;
  hidePagination?: boolean;
}

export const PaginationComponent: FC<IPaginationComponentProps> = (props) => {
  const {
    pageSizeOptions = defaultPageSizeOptions,
    total,
    paginationModel,
    hidePagination,
  } = props;

  const disabled =
    props["aria-disabled"] === "true" || props["aria-disabled"] === true;

  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("sm"));
  const apiRef = useGridApiContext();
  const { page = 1, pageSize = defaultPageSizeOptions[0] } =
    paginationModel || {};

  const count = Math.ceil(total / pageSize);
  const isHiddenPagination = total < 11 || hidePagination;

  return (
    <Box
      sx={{
        justifyContent: "space-between",
        width: "100%",
        display: "flex",
        alignItems: "center",
        overflow: "auto",
        px: 5,
      }}
    >
      {!isHiddenPagination && (
        <Box
          sx={{
            display: "flex",
            width: { xs: "auto" },
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              whiteSpace: "nowrap",
            }}
          >
            <Typography
              variant="body2"
              sx={{
                color: "text.primary",
                mr: 2,
              }}
            >
              Показывать по
            </Typography>
            <SelectField
              disabled={disabled}
              size="small"
              onChange={(e) =>
                apiRef.current.setPageSize(Number(e.target.value))
              }
              sx={{
                [`&.MuiInputBase-root`]: {
                  [`& .MuiSelect-select`]: {
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: 2,
                    paddingRight: 5,
                    bgcolor: "white",
                  },
                  ["& svg"]: {
                    fontSize: "1.2rem",
                    right: 4,
                  },
                  [`& .MuiOutlinedInput-notchedOutline`]: {
                    borderWidth: 1,
                    borderRadius: 1.5,
                  },
                  [`&.Mui-focused .MuiOutlinedInput-notchedOutline`]: {
                    borderColor: "grey.500",
                  },
                },
              }}
              variant="outlined"
              value={pageSize}
              options={pageSizeOptions.map((option) => ({
                value: option,
                name: option.toString(),
              }))}
            />
          </Box>
        </Box>
      )}
      {/* TODO uncomment if need page info */}
      {/* {!isHiddenPagination && (
        <Typography lineHeight={1.25} minWidth={{ xs: "auto", sm: 110 }}>
          {page * pageSize + 1}-
          {(page + 1) * pageSize > total ? total : (page + 1) * pageSize} of
          &nbsp;
          {total}
        </Typography>
      )} */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Pagination
          disabled={disabled}
          color="standard"
          variant="text"
          page={page + 1}
          hidden={isHiddenPagination}
          siblingCount={isDesktop ? undefined : 0}
          boundaryCount={isDesktop ? undefined : 0}
          showFirstButton
          showLastButton
          count={count}
          onChange={(_event: React.ChangeEvent<unknown>, value: number) =>
            apiRef.current.setPage(value - 1)
          }
          sx={{
            ["&>ul"]: { flexWrap: "nowrap" },
            ["li:first-of-type"]: {
              marginRight: theme.spacing(2),
            },
            ["li:last-of-type"]: {
              marginLeft: theme.spacing(2),
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default React.memo(PaginationComponent);
